import MetaEntities from '../../../components/Admin/MetaEntities/MetaEntities'

export default function MetaEntitiesScreen(userToken: any){
  const oauthTokenHeader = userToken?.userToken;
  
  return(
    <MetaEntities oauthTokenHeader={oauthTokenHeader}/>
  )
}